import React from 'react';
import { ProgressLoadingBar } from '@ohif/ui-next';
import { LoadingMark } from './BrandIcons/LoadingMark';

type SycaiLoadingIndicatorProps = {
  className?: string;
  textBlock?: React.ReactNode;
  progress?: number;
};

export function SycaiLoadingIndicator({
  className,
  textBlock,
  progress,
}: SycaiLoadingIndicatorProps) {
  return (
    <div
      className={[
        'absolute top-0 left-0 z-50 flex flex-col items-center justify-center space-y-5',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <LoadingMark />
      <div className="w-48">
        <ProgressLoadingBar progress={progress} />
      </div>
      {textBlock}
    </div>
  );
}

export default SycaiLoadingIndicator;
